<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    let myData1 = [
      {
        value: 1307.07,
        name: "网店销售",
      },
      {
        value: 1922.77,
        name: "直播带货",
      },
      {
        value: 930.6,
        name: "线下销售",
      },
      {
        value: 539.56,
        name: "门店销售",
      },
    ];
    let colorA = ["#F26C4F", "#F94FFF", "#FFD200", "#00E1EF"];
    this.state.chart.setOption({
      title: {
        text: "100%",
        top: "46%",
        left: "24%",
        textStyle: {
          fontSize: 26,
          color: "#ffffff",
        },
      },
      legend: {
        orient: "vertical",
        icon: "circle",
        right: "8%",
        y: "center",
        itemWidth: 20,
        itemHeight: 20,
        itemGap: 30,
        align: "left",
        textStyle: {
          rich: {
            name: {
              // width: '45%',
              fontSize: 24,
              color: "#fff",
            },
            value: {
              fontSize: 24,
              padding: [0, 5, 0, 15],
              color: "#00E1EF",
            },
          },
        },
        formatter: function (name) {
          let res = myData1.filter((v) => v.name === name);
          res = res[0] || {};
          const p = res.value;
          return "{name|" + name + "：}" + "{value|" + p + "万}";
          // return "{name|" + name + "}";
        },
      },
      tooltip: {
        show: false,
        confine: true,
        trigger: "item",
        formatter: "{b} : {c}",
      },
      series: [
        {
          avoidLabelOverlap: false,
          type: "pie",
          roseType: "area", // 玫瑰图
          center: ["30%", "50%"],
          radius: ["30%", "46%"],
          color: colorA,
          itemStyle: {
            normal: {
              borderColor: "#050F20",
              borderWidth: 3,
            },
          },
          label: {
            normal: {
              //   formatter: '{b}\n{d}%\t{c}',
              formatter: "{b|{b}}\n{d|{d}%}",
              rich: {
                icon: {
                  fontSize: 20,
                },
                d: {
                  fontSize: 20,
                  padding: [5, 0, 0, 0],
                  color: "#fff",
                },
                b: {
                  fontSize: 20,
                  padding: [0, 0, 5, 0],
                  color: "#fff",
                },
              },
            },
          },
          labelLine: {
            normal: {
              length: 10,
              length2: 25,
            },
          },
          data: myData1,
        },
      ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
